 import React from 'react';
import { t } from '../../../lib/i18n';
import styled from 'styled-components';

function Imprint() {
    return (
        <div>
            <h1>{t('imprint.title')}</h1>
            <div>
                <p><address>
                    TVSMILES GmbH<br />
                    Friedrichstraße 45<br />
                    10969 Berlin<br />
                </address></p>

                <p>{t('imprint.court')}</p>
                <p>{t('imprint.hrb')}</p>
                <p>{t('imprint.ceos')}</p>
                <p>{t('imprint.vatNumber')}</p>
                <p>{t('imprint.responsible')}</p>
            </div>
        </div>
    );

}

const StyledImprint = styled(Imprint)`
    p + p {
        margin-top: 1em
    }
`;

export default StyledImprint;


// WEBPACK FOOTER //
// ./src/pages/status-overview/imprint/imprint.jsx